<template>
  <v-container class="pb-0">
    <div class="d-flex align-center">
      <span class="pr-5 text-007C92 w-500 font-18">ประวัติการรักษา</span>
      <v-divider></v-divider>
    </div>
    <v-row>
      <v-col cols="12" lg="5">
        <v-row class="px-0 mx-0">
          <v-col cols="12" lg="5" align-self="center">
            <v-select
              solo
              dense
              hide-details="auto"
              v-model="selectYear"
              :items="itemYear"
              item-value="value"
              item-text="text"
              @input="filter"
            >
              <template v-slot:prepend> ปี </template>
            </v-select>
          </v-col>
          <v-col cols="12" lg="5" align-self="center">
            <v-select
              solo
              dense
              hide-details="auto"
              item-text="text"
              v-model="selectMonth"
              item-value="value"
              :items="months"
              @input="filter"
            >
              <template v-slot:prepend> เดือน </template>
            </v-select>
          </v-col>
          <v-col
            cols="12"
            lg="2"
            align-self="center"
            class="d-flex justify-end"
          >
            <span class="text-007C92 font-16 w-500">
              {{ items.total || 0 }} <span class="font-16 w-300">ครั้ง</span>
            </span>
          </v-col>
          <v-col cols="12" lg="12" style="overflow-x: auto;max-height: 550px;">
            <v-list dense>
              <v-list-item-group v-model="selectedItem">
                <v-list-item
                  v-for="(item, i) in items.result"
                  :key="i"
                  class="my-2"
                  :value="item.value"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      <div class="d-flex flex-column">
                        <span class="w-500 font-18">{{
                          convertDate(item.queues)
                        }}</span>
                        <span class="w-300 font-16 mt-2">{{
                          convertTime(item.queues)
                        }}</span>
                      </div>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="7">
        <v-row class="pa-0 ma-0" v-if="items.total > 0">
          <v-col cols="12" lg="12">
            <span class="w-500 font-24 text-007C92">{{
              convertDate(items.result[selectedItem].queues)
            }}</span>
            <span class="w-300 font-16 text-09425A ml-3">{{
              convertTime(items.result[selectedItem].queues)
            }}</span>
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12" lg="12" class="d-flex flex-column">
            <span class="w-500 font-18 text-navy-50">บันทึกทางการแพทย์</span>
            <div>
              <span class="w-300 font-18 text-navy-50">อาการสำคัญ</span>
              <v-text-field
                solo
                dense
                :readonly="view"
                placeholder="กรอกอาการสำคัญ"
                v-model="items.result[selectedItem].marjor_symptoms"
              />
            </div>
            <div>
              <span class="w-300 font-18 text-navy-50">อาการปัจจุบัน </span>
              <v-text-field
                solo
                dense
                :readonly="view"
                placeholder="กรอกอาการปัจจุบัน"
                v-model="items.result[selectedItem].current_symptoms"
              />
            </div>
            <div>
              <span class="w-300 font-18 text-navy-50">โรคประจำตัว</span>
              <v-text-field
                solo
                :readonly="view"
                dense
                placeholder="กรอกโรคประจำตัว"
                v-model="items.result[selectedItem].congenital_disease"
              />
            </div>
            <!-- <div v-if="false">
              <span class="w-300 font-18 text-navy-50">
                รหัสโรค ICD10 (โรค)
              </span>
              <v-text-field
                solo
                dense
                hide-details
                placeholder="กรอกรหัสโรค ICD10 (โรค)"
                v-for="(t, index) in totalCD10"
                v-model="items[selectedItem].icd10[index]"
                class="mb-2"
                :key="`icd10-${t}${index}`"
              />
              <div
                class="d-flex justify-end align-center"
                @click="itemsICD10 += 1"
              >
                <v-btn small icon color="primary">
                  <v-icon>mdi-plus-circle-outline</v-icon>
                </v-btn>
                <span class="w-500 font-14 text-336AB4">เพิ่มข้อมูล</span>
              </div>
            </div>
            <div v-if="false">
              <span class="w-300 font-18 text-navy-50">
                รหัสหัตถการ ICD9 (หัตถการ)
              </span>
              <v-text-field
                solo
                dense
                hide-details
                placeholder="กรอกรหัสหัตถการ ICD9 (หัตถการ)"
                v-for="(t, index) in totalCD9"
                v-model="items[selectedItem].icd9[index]"
                class="mb-2"
                :key="`icd9-${t}${index}`"
              />
              <div
                class="d-flex justify-end align-center"
                @click="itemsICD9 += 1"
              >
                <v-btn small icon color="primary">
                  <v-icon>mdi-plus-circle-outline</v-icon>
                </v-btn>
                <span class="w-500 font-14 text-336AB4">เพิ่มข้อมูล</span>
              </div>
            </div>
            <div v-if="false">
              <span class="w-300 font-18 text-navy-50"
                >รายการสั่งตรวจ Lab / Xray</span
              >
              <v-text-field
                solo
                dense
                placeholder="กรอกรายการสั่งตรวจ Lab / Xray"
                v-model="items[selectedItem].inspection"
              />
            </div> -->
            <div>
              <span class="w-300 font-18 text-navy-50">บันทึกทางการแพทย์</span>
              <v-text-field
                solo
                dense
                :readonly="view"
                placeholder="กรอกบันทึกทางการแพทย์"
                v-model="items.result[selectedItem].medicalRecord"
                hide-details
              />
            </div>
            <div
              style="border-top: 1px solid #09425a; background: #09425a"
              class="my-5"
            ></div>
            <div class="d-flex justify-end pt-3">
              <v-btn width="30%" color="#1CA7B4" @click="closePage" outlined
                >ยกเลิก</v-btn
              >
              <div class="px-2"></div>
              <v-btn width="30%" dark color="#1CA7B4" @click="put" v-if="!view"
                >บันทึก</v-btn
              >
            </div>
          </v-col>
        </v-row>
        <v-row v-if="items.total === 0">
          <v-col
            cols="12"
            lg="12"
            class="noitems d-flex justify-center align-center"
          >
            <h2>ไม่มีประวัติการรักษา</h2>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      selectYear: 2021,
      selectMonth: 0,
      months: [
        { value: 0, text: "ทั้งหมด" },
        { value: "01", text: "มกราคม" },
        { value: "02", text: "กุมภาพันธ์" },
        { value: "03", text: "มีนาคม" },
        { value: "04", text: "เมษายน" },
        { value: "05", text: "พฤษภาคม" },
        { value: "06", text: "มิถุนายน" },
        { value: "07", text: "กรกฎาคม" },
        { value: "08", text: "สิงหาคม" },
        { value: "09", text: "กันยายน" },
        { value: 10, text: "ตุลาคม" },
        { value: 11, text: "พฤศจิกายน" },
        { value: 12, text: "ธันวาคม" },
      ],
      selectedItem: 0,
      // items: [
      //   { date: "10 เมษายน 2564", time: "09:00 - 09:30 น.", value: "text-1" },
      //   { date: "10 เมษายน 2564", time: "09:00 - 09:30 น.", value: "text-2" },
      //   { date: "10 เมษายน 2564", time: "09:00 - 09:30 น.", value: "text-3" },
      // ],
      itemsICD10: 1,
      itemsICD9: 1,
    };
  },
  props: {
    reset: { type: Boolean, default: true },
  },
  watch: {
    reset() {
      this.reset_data();
    },
  },

  computed: {
    ...mapGetters({
      items: "setMedicalHistoryGetter",
      view: "viewHistoryTalkingGetter",
      currentPatient: "currentPatientGetter",
    }),

    itemYear() {
      // console.log(moment().year());
      let y = [];
      y.push({ value: moment().year() - 1, text: moment().year() - 1 + 543 });
      y.push({ value: moment().year(), text: moment().year() + 543 });
      y.push({ value: moment().year() + 1, text: moment().year() + 1 + 543 });

      // console.log(y);
      return y;
    },
    totalCD9() {
      // if (this.items[this.selectedItem].icd9 === null) return 1
      const total = this.items.result[this.selectedItem].icd9.length;
      if (total === 0) return 1;
      return total;
    },
    totalCD10() {
      // if (this.items[this.selectedItem].icd10 === null) return 1
      const total = this.items.result[this.selectedItem].icd10.length;
      if (total === 0) return 1;
      return total;
    },
  },
  methods: {
    closePage() {
      // this.$store.state.personalPatientDialog = false;
      this.$emit("close");
      this.reset_data();
    },
    reset_data() {
      this.selectYear = moment().year();
      this.selectMonth = 0;
      this.selectedItem = 0;
    },
    convertDate(date = "") {
      const { date: date_diagnotic } = date;
      // console.log(date_diagnotic);
      var year1 = moment(date_diagnotic).locale("th").format("YYYY")
      var year2 = (parseInt(year1) + 543).toString()
      return moment(date_diagnotic).locale("th").format("DD/MMMM/" + year2)
    },
    convertTime(time = "") {
      const { time_slot_start, time_slot_end } = time;
      return `${time_slot_start || ""} - ${time_slot_end || ""} น.`;
    },
    filter() {
      // const { patient_id: id } = this.items[this.selectedItem]
      let dateMonth = this.selectMonth;
      if (this.selectMonth === 0) dateMonth = "";
      this.$store.dispatch("getMedicalHistoryAction", {
        patient_id: this.currentPatient,
        dentist_clinic_id: sessionStorage.dentist_clinic_id,
        year: this.selectYear,
        month: dateMonth,
      });
      this.selectedItem = 0;
    },
    async put() {
      const { _id: id } = this.items.result[this.selectedItem];
      const { data: { message } = {} } = await this.axios.put(
        process.env.VUE_APP_BASE_URL + `/diagnostic_history?id=${id}`,
        this.items.result[this.selectMonth]
      );
      await this.$store.dispatch("actionLog", {
        action: "edit diagnostic history",
        action_by: sessionStorage.account_id,
        path: `/diagnostic_history`,
        params: {
          id: id
        },
        body: this.items.result[this.selectMonth]
      });
      if (message === "success") {
        Swal.fire({
          type: "success",
          width: 366,
          imageUrl: `${require("@/assets/icon/Succes_G.png")}`,
          imageWidth: 100,
          imageHeight: 100,
          title: '<b class="alert">แก้ไขข้อมูลสำเร็จ</b>',
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          position: "center",
          timer: 3000,
          backdrop: false,
        });
      }
      // console.log(data)
    },
  },
};
</script>

<style lang="scss" scoped>
.left-content {
  width: 45%;
}
.right-content {
  width: 55%;
  // height: 100vh;
  margin-top: -12px;
  // margin-bottom: -12px;
  border-left: 1px solid #babdbf;
}
.v-list-item-group .v-list-item--active {
  color: #fff;
  background: #0e535a;
}
.v-list-item {
  background: #e8f6f7;
  color: #000;
}
::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}
.noitems {
  height: 60vh;
}
</style>
